import React from 'react';
import classNames from 'classnames';
import { Icons, PrimaryButton } from '../../../components';
import { isArrayLength } from '../../../util/genericHelpers';
import { FormattedMessage } from 'react-intl';
import css from './Sections.module.css';
import { getTalentServiceDescription } from '../../../config/configExtras';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useRouteConfiguration } from '../../../context/routeConfigurationContext';
import { createResourceLocatorString } from '../../../util/routes';
import { SignatureServiceTypes } from '../../../util/enums';

function SectionAutographs({ selectedSignatureService, providerServices, title, listing }) {
  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();
  const listingId = listing?.id?.uuid;

  const shoutouts =
    (isArrayLength(providerServices) && providerServices.filter(s => s?.selected)) || [];

  const navigateToServiceOfferingsPage = (shoutout, customItem = null) => {
    const finalTitle = customItem ? customItem.title : shoutout.option;
    const finalPrice = customItem ? customItem.price : shoutout.price;
    const pathname = createResourceLocatorString(
      'ServiceOfferingsPage',
      routeConfiguration,
      { id: listingId, type: SignatureServiceTypes.SHOUTOUTS_OR_GREETINGS },
      {}
    );

    history.push({
      pathname,
      state: {
        item: {
          title: finalTitle,
          price: finalPrice,
        },
      },
    });
  };

  return (
    <>
      <div className={css.getCustomVideo}>
        <h2>
          {selectedSignatureService?.title}{' '}
          <FormattedMessage id="SectionAutographs.from" values={{ title }} />
        </h2>
      </div>

      {isArrayLength(shoutouts)
        ? shoutouts.map(shoutout => {
            const isCustom = shoutout.option === 'Custom' && isArrayLength(shoutout.customItems);

            // If it's a regular shoutout (not Custom) → render once
            if (!isCustom) {
              return (
                <div className={css.bookingSec} key={shoutout.option}>
                  <div className={classNames(css.offerSec, css.withoutIconSec)}>
                    <div className={css.offerContent}>
                      <h2>{shoutout.option}</h2>
                      {shoutout.price && <p>${Number(shoutout.price).toFixed(2)}</p>}
                      <p>{getTalentServiceDescription(shoutout.option)}</p>

                      <PrimaryButton
                        className={css.bookBtn}
                        type="button"
                        onClick={() => navigateToServiceOfferingsPage(shoutout)}
                      >
                        <Icons name="security" />
                        <FormattedMessage id="SectionAutographs.buyNow" />
                      </PrimaryButton>
                    </div>
                  </div>
                </div>
              );
            }

            // If it's Custom → render every customItem as a separate card
            return shoutout.customItems.map(customItem => (
              <div className={css.bookingSec} key={customItem.title}>
                <div className={classNames(css.offerSec, css.withoutIconSec)}>
                  <div className={css.offerContent}>
                    <h2>{customItem.title}</h2>
                    <p>${Number(customItem.price).toFixed(2)}</p>
                    <p>{getTalentServiceDescription('Custom Shoutout')}</p>

                    <PrimaryButton
                      className={css.bookBtn}
                      type="button"
                      onClick={() => navigateToServiceOfferingsPage(shoutout, customItem)}
                    >
                      <Icons name="security" />
                      <FormattedMessage id="SectionAutographs.buyNow" />
                    </PrimaryButton>
                  </div>
                </div>
              </div>
            ));
          })
        : null}
    </>
  );
}

export default SectionAutographs;
